import { StyleSheet } from 'react-native';

import { useLocale } from '../../hooks/useLocale';
import { useStaticTranslation } from '../../services/staticTranslations';
import { Languages } from '../../util/enums';

const LogoWithNameImage = ({ style }) => {
  const useFrench = useLocale() === Languages.french;
  const oneX = useFrench
    ? require('./logo-with-name-fr.png')
    : require('./logo-with-name.png');
  const twoX = useFrench
    ? require('./logo-with-name-fr@2x.png')
    : require('./logo-with-name@2x.png');
  const width = useFrench ? 221 : 265;
  return (
    <img
      src={twoX}
      style={StyleSheet.flatten([{ height: 54, width }, style])}
      srcSet={`${oneX}, ${twoX} 2x`}
      alt={useStaticTranslation('BreathingRoom')}
    />
  );
};

export { LogoWithNameImage };
